import React from "react";
import { Link, useLocation } from "react-router-dom";
import services from "../data/services";
import ContactUs from "../components/contactUs/ContactUs";
import "./ServiceDetail.css";

const ServiceDetail = () => {
  const { pathname } = useLocation();
  let currentPath = pathname;
  try { currentPath = decodeURIComponent(pathname); } catch { /* Keep malformed URLs harmless. */ }
  currentPath = currentPath.replace(/\/+$/, "").toLocaleUpperCase("sv-SE");
  const service = services.find(({ path }) => path === currentPath);
  if (!service) return null;

  return (
    <>
      <article className="service-detail" aria-labelledby="service-title">
        <header className="service-detail-header">
          <div className="site-container">
            <nav className="service-detail-breadcrumbs" aria-label="Brödsmulor">
              <ol>
                <li><Link to="/">Startsida</Link></li>
                <li><Link to="/#services">Våra tjänster</Link></li>
                <li><span aria-current="page">{service.title}</span></li>
              </ol>
            </nav>
            <div className="service-detail-hero">
              <div className="service-detail-lead">
                <p className="site-eyebrow">THAS Ekonomi & Redovisning</p>
                <h1 id="service-title">{service.title}</h1>
                <p className="service-detail-intro">{service.intro}</p>
                <div className="service-detail-actions">
                  <Link className="site-button" to={`${service.path}#contact`}>Kontakta oss <span aria-hidden="true">↗</span></Link>
                  <Link className="site-text-link" to="/#priser">Se priser & paket</Link>
                </div>
              </div>
              <aside className="service-detail-summary" aria-labelledby="service-summary-title">
                <span className="service-detail-summary-mark" aria-hidden="true">↗</span>
                <h2 id="service-summary-title">Det här kan vi hjälpa dig med</h2>
                <ul>{service.inclusions.map((item) => <li key={item}>{item}</li>)}</ul>
                <p>Vi kommer överens om omfattning och pris innan arbetet börjar.</p>
              </aside>
            </div>
          </div>
        </header>
        <div className="service-detail-content">
          <div className="site-container service-detail-content-grid">
            <div className="service-detail-sections">
              {service.sections.map(({ heading, text }, index) => (
                <section className="service-detail-section" key={heading} aria-labelledby={`service-section-${index}`}>
                  <p className="site-eyebrow" aria-hidden="true">0{index + 1}</p>
                  <h2 id={`service-section-${index}`}>{heading}</h2>
                  <p>{text}</p>
                </section>
              ))}
            </div>
            <nav className="service-detail-related" aria-labelledby="related-services-heading">
              <p className="site-eyebrow">Hjälp med helheten</p>
              <h2 id="related-services-heading">Fler tjänster</h2>
              <ul>{services.filter(({ path }) => path !== service.path).map(({ path, title }) => (
                <li key={path}><Link to={path}>{title}<span aria-hidden="true">↗</span></Link></li>
              ))}</ul>
              <Link className="site-text-link" to="/#priser">Utforska paket & priser</Link>
            </nav>
          </div>
        </div>
      </article>
      <div id="contact"><ContactUs /></div>
    </>
  );
};

export default ServiceDetail;
